import { Text } from '@chakra-ui/react';
import { Trans } from '@lingui/macro';

import InputCheckbox from '../../generic/form/InputCheckbox';

const textProps = {
  as: 'span',
  fontSize: 'xs',
};

export const OPT_IN_FIELDNAME = 'opt_in';

const CheckoutOptIn = ({ ...dataProps }) => {
  return (
    <InputCheckbox fieldName={OPT_IN_FIELDNAME} {...dataProps} isRequired={false}>
      <Text {...textProps}>
        <Trans>I agree to receive marketing emails</Trans>{' '}
      </Text>
    </InputCheckbox>
  );
};

export default CheckoutOptIn;
